import { Alert, Link, t } from '@kanbios/ui';
import type { maintenance } from '@kanbios/api-client';

export type PullRequest = maintenance.components['schemas']['PullRequest'];
const TONES = { open: 'info', validation_failed: 'neg', merged: 'info', applied: 'pos', closed: 'info' } as const;

/** D81: a change is a commit on main (its short SHA); one made before is a pull request (#number). */
export const changeRef = (change: Pick<PullRequest, 'commit' | 'number'>) => change.commit ?? `#${change.number}`;

/**
 * A change written to the catalogue (ADR-005, SPEC-006 RG-006-13): the
 * intermediate state is always said, with the link, until it is applied.
 */
export function PullRequestNotice({ pullRequest }: { pullRequest: PullRequest | null | undefined }) {
  if (!pullRequest) return null;
  const { state, reviewers, ciMessage, url, autoMerge, commit } = pullRequest;
  const ref = changeRef(pullRequest);
  // D81: a commit is « merged » at once; the states before are those of a pull request opened before.
  const key = commit ? `pullRequest.commit.${state}` : `pullRequest.${state}`;
  // D26: an administrator's change merges itself once the catalogue's check passes, unless GitHub refuses.
  const body = state === 'open' && autoMerge ? (ciMessage ? 'pullRequest.open.autoMergeRefused' : 'pullRequest.open.autoMerge') : `${key}.body`;
  return (
    <Alert tone={state === 'open' && autoMerge && ciMessage ? 'warn' : TONES[state]} title={t(`${key}.title`, { ref })}>
      {t(body, { ref, reviewers: reviewers.join(', ') || t('pullRequest.noReviewer'), message: ciMessage ?? '' })}{' '}
      <Link href={url} external>{t('pullRequest.link', { ref })}</Link>
    </Alert>
  );
}
